import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 20l-3 -8l3 -8","key":"svg-0"}]]

const IconChevronCompactLeft = createReactComponent('outline', 'chevron-compact-left', 'ChevronCompactLeft', __iconNode);

export default IconChevronCompactLeft;